import {
  SignalCellular3BarOutlined,
  SignalCellular4BarOutlined,
  SignalCellular1BarOutlined,
} from "@mui/icons-material";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

export default function CardFeedBackPower({ connectionData }) {
  const theme = useTheme();
  const nivel = useMemo(
    () => connectionData?.qualityPower || 0,
    [connectionData]
  );
  const color = useMemo(
    () => connectionData?.corPower?.cor || theme.palette.color.textDisabled,
    [connectionData, theme]
  );

  const styles = {
    icons: {
      color: color,
      fontSize: "20px",
    },
    info: {
      color: theme.palette.color.textDisabled,
      width: "100%",
    },
    statusCard: {
      backgroundColor: "transparent",
      paddingX: "10px",
      paddingY: "0px",
      display: "flex",
      gap: 2,
      height: "60px",
    },
    line: { backgroundColor: "#FFFFFF", width: "3px", height: "100%" },
  };

  const niveis = [
    {
      icon: <SignalCellular1BarOutlined sx={styles.icons} />,
      text: "Sem recepção do sinal",
    },
    {
      icon: <SignalCellular1BarOutlined sx={styles.icons} />,
      text: "A recepção do sinal está ruim e instável",
    },
    {
      icon: <SignalCellular3BarOutlined sx={styles.icons} />,
      text: "A recepção do sinal está em boas condições",
    },
    {
      icon: <SignalCellular4BarOutlined sx={styles.icons} />,
      text: "A recepção  do sinal está em condições excelentes",
    },
  ];

  return (
    <Paper sx={styles.statusCard} elevation={0} variant="miniCards">
      <Stack direction={"column"} width={"100%"} gap={0.5}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography variant="default">{"Status da potência"}</Typography>
          {niveis[nivel]?.icon}
        </Stack>
        {
          <Typography sx={styles.info} variant="small">
            {niveis[nivel]?.text}
          </Typography>
        }
      </Stack>
    </Paper>
  );
}
